import React from 'react';
import {Button} from "./Button";
import {goBack} from 'react-router-redux';
import {connect} from 'react-redux';

class BackButtonContainer extends React.Component {

  render(){
    const props = { ...this.props };

    delete props.back;

    return (
      <Button { ...props } onClick={this.props.back}
              shape={"block"}
              size={"sm"}/>
    );
  }
}

export const BackButton = connect(
  null,
  dispatch => ({
    back: event => {
      dispatch(goBack());
      event.preventDefault();
    }
  })
)(BackButtonContainer);



// WEBPACK FOOTER //
// ./src/components/button/BackButton.js